import React from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { dateEntries } from "../../../constants/dates";

export const DateWrapper = ({
  selectedDates,
  handleSelectDates,
  handleSelectMonths,
  dates,
  hideTitle = false,
  useTailwind = false,
}) => {
  const { t } = useTranslation();

  if (useTailwind) {
    return (
      <div>
        {!hideTitle && (
          <p className="tw-text-xl tw-font-extrabold tw-text-gray-900 tw-mb-3">
            {isMobile
              ? t("when_trip", { defaultValue: "When's your trip?" })
              : t("dates", { defaultValue: "Dates" })}
          </p>
        )}
        <div className="tw-grid tw-grid-cols-3 tw-gap-2">
          {dates.map((date, key) => {
            const dateEntry = dateEntries[date];
            const isSelected = selectedDates.includes(date);

            return (
              <button
                key={key}
                type="button"
                onClick={() => {
                  handleSelectDates(date);
                  handleSelectMonths(key + 1);
                }}
                className={`tw-h-11 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-text-sm tw-font-semibold tw-transition-colors ${
                  isSelected
                    ? "tw-bg-white tw-text-gray-900"
                    : "tw-bg-white tw-text-gray-700"
                }`}
                style={{
                  border: isSelected ? "2px solid #222" : "1px solid #e5e7eb",
                }}
              >
                {t(`months.${dateEntry}`, { defaultValue: date })}
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  // Legacy SCSS-based rendering for existing desktop Filter usage
  return (
    <div className="DateContainer">
      {!hideTitle &&
        (isMobile ? (
          <p style={{ fontWeight: "800", fontSize: "20px" }}>
            {t("when_trip", {
              defaultValue: "When's your trip?",
            })}
          </p>
        ) : (
          <p style={{ fontWeight: "800" }}>
            {t("dates", {
              defaultValue: "Dates",
            })}
          </p>
        ))}
      <div className="DatesBox">
        {dates.map((date, key) => {
          const dateEntry = dateEntries[date];

          return (
            <button
              key={key}
              className={`DateBox ${selectedDates.includes(date) ? "selected" : ""}`}
              onClick={() => {
                handleSelectDates(date);
                handleSelectMonths(key + 1);
              }}
            >
              {t(`months.${dateEntry}`, {
                defaultValue: date,
              })}
            </button>
          );
        })}
      </div>
    </div>
  );
};
